module.exports = require('ember-tool').extend(require('ember-period-field').PeriodFieldMixin,
    {
        icon: 'calendar',

        text: Em.computed.alias('value.name'),

        hasAction: true
    }
);
